import React, { Fragment } from 'react';

import Views from '../../Views';
import useMembershipTypesO15 from './UseMembershipTypesO15';
import OfferingTypesGrid from './grids/OfferingTypesGrid';
import ViewTemplate from '../../components/viewTemplate/ViewTemplate';
import ErrorHandle from '../components/ErrorHandle';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

import style from '../Omr.module.css';

const MembershipTypesO15 = () => {
  const {
    displayPopUp,
    showNoMembershipsAvailable,
    personState,
    state,
    offeringTypeState,
    onBackToWelcomeButtonClicked,
    onBackButtonClicked,
    onShowMembershipHistory,
    onNextButtonClicked,
    onAllMembershipCheck,
    restrictions
  } = useMembershipTypesO15();

  if (showNoMembershipsAvailable === true) {
    return (
      <Fragment>
        <div className="col-xs-12">
          <p className={style.CenterAlign}>There are currently no memberships available for this registrant, please check back later.</p>
        </div>
        <div className={['row usas-extra-top-margin', style.CenterAlign].join(' ')}>
          <PrimaryButton onClick={onBackToWelcomeButtonClicked}>Back to Welcome Screen</PrimaryButton>
        </div>
      </Fragment>
    );
  } else {
    return (
      <ViewTemplate
        viewName={Views.MEMBERSHIP}
        onBackButtonClicked={onBackButtonClicked}
        onNextButtonClicked={onNextButtonClicked}>
        {
          personState?.person?.personId
            ? (
              <div className='row'>
                <div className='col-xs-12 usas-extra-bottom-margin'>
                  <ActionIntraPageButton
                    className='pull-right'
                    onClick={onShowMembershipHistory}>Show Membership History
                  </ActionIntraPageButton>
                </div>
              </div>
            )
            : <Fragment />
        }
        <OfferingTypesGrid
          state={offeringTypeState}
          selectedOfferingTypeIds={state.selectedOfferingTypeIds}
          onChanged={onAllMembershipCheck}
          restrictions={restrictions} />
        <ErrorHandle error={state.errorMessage} message={state.errorMessage} />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={displayPopUp} />
      </ViewTemplate>
    );
  }
};

export default MembershipTypesO15;